exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.text-center, .text-center h5 {\n  text-align:center!important\n}\n.no-data-img {\n  display: inline\n}\n.NavTabs {\n  display: flex;\n  overflow-x: auto;\n  white-space: nowrap;\n  -webkit-overflow-scrolling: touch;\n  scrollbar-width: none; /* Firefox */\n}\n.NavTabs::-webkit-scrollbar {\n  display: none; /* Chrome, Safari, Edge */\n}\n@media (max-width: 768px) {\n.tab {\n    flex: 0 0 auto;\n}\n}\n", ""]);

// exports
